module.exports = __webpack_public_path__ + "static/img/EP202504081424411.54b9424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424411.jpg
// module id = cxxN
// module chunks = 1